import {
  defaultExperience,
  experienceWhenShellAuthUnavailable,
  iframeExpiredUrlForExperience,
  iframeUrlForExperience,
} from './config'
import { fetchContactAuth } from './contactAuth'
import { writePersistedExperienceForToken } from './persistedExperience'
import {
  resolveShellExperience,
  type Dev2222Mode,
  type Experience,
} from './experience'

export type ShellEmbedTarget =
  | { kind: 'contact-token'; token: string }
  | { kind: 'expired-page' }

export type ResolvedShellEmbed = {
  experience: Experience
  target: ShellEmbedTarget
  jwtPayload: Record<string, unknown> | null
  jwtPreview: string
  notice?: string
}

export function shellEmbedIframeSrc(resolved: ResolvedShellEmbed): string {
  if (resolved.target.kind === 'expired-page') {
    return iframeExpiredUrlForExperience(resolved.experience)
  }
  return iframeUrlForExperience(resolved.experience, resolved.target.token)
}

export function resolveShellEmbedWithoutToken(pathExperience?: Experience): ResolvedShellEmbed {
  return {
    experience: experienceWhenShellAuthUnavailable(pathExperience),
    target: { kind: 'contact-token', token: '' },
    jwtPayload: null,
    jwtPreview: '{}',
    notice: 'Missing token in path',
  }
}

export async function resolveShellEmbedForContactToken(
  token: string,
  pathExperience: Experience | undefined,
  dev2222Mode: Dev2222Mode,
): Promise<ResolvedShellEmbed> {
  const auth = await fetchContactAuth(token)
  if (auth.kind === 'ready') {
    const experience = resolveShellExperience(
      auth.jwtPayload,
      pathExperience,
      dev2222Mode,
      defaultExperience,
    )
    writePersistedExperienceForToken(token, experience)
    return {
      experience,
      target: { kind: 'contact-token', token },
      jwtPayload: auth.jwtPayload,
      jwtPreview: auth.jwtPreview,
    }
  }
  const experience = experienceWhenShellAuthUnavailable(pathExperience, token)
  const target: ShellEmbedTarget =
    auth.status === 410 ? { kind: 'expired-page' } : { kind: 'contact-token', token }
  return {
    experience,
    target,
    jwtPayload: null,
    jwtPreview: '{}',
    notice: auth.message,
  }
}
